// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatarusd } from "../../../icons/full/build/icon-statarusd.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatarusdIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatarusd.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatarusdIcon.displayName = 'StatarusdIcon';
}

export default StatarusdIcon;